import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './product-select.component.html';
var ProductSelectComponent = (function () {
    function ProductSelectComponent() {
        this.screenXstart = 0;
        this.screenXstop = 0;
    }
    ProductSelectComponent.prototype.getImageUrl = function (images) {
        if (images === void 0) { images = []; }
        var filteredImages = images.filter(function (image) { return /\.(jpg|jpeg|png)+/.test(image.url); });
        if (filteredImages.length === 0) {
            return '';
        }
        return filteredImages[0].url;
    };
    ProductSelectComponent.prototype.selectProduct = function (index) {
        if (Math.abs(this.screenXstart - this.screenXstop) <= 10) {
            this.selectedProduct = this.products[index];
        }
    };
    ProductSelectComponent.prototype.registerDragStart = function (event) {
        this.screenXstart = event.screenX;
    };
    ProductSelectComponent.prototype.registerDragStop = function (event) {
        this.screenXstop = event.screenX;
    };
    ProductSelectComponent.prototype.getSlidesCountToShow = function () {
        if (!this.products)
            return;
        var maxSlides = this.withFilters ? 3 : 4;
        return this.products.length >= maxSlides ? maxSlides : this.products.length;
    };
    ProductSelectComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ProductSelectComponent.prototype, "products", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ProductSelectComponent.prototype, "withFilters", void 0);
    __decorate([
        Input('='),
        __metadata("design:type", Object)
    ], ProductSelectComponent.prototype, "selectedProduct", void 0);
    ProductSelectComponent = __decorate([
        Component({
            selector: 'productSelect',
            template: template,
        })
    ], ProductSelectComponent);
    return ProductSelectComponent;
}());
export { ProductSelectComponent };
